export default "__VITE_ASSET__Cuuk2pQF__"